import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/ContactUs.css";
import ContactImage from "../assets/ContactUs.jpg"; // Ensure correct path

const ContactUs = () => {
  return (
    <section id="contact" className="contact-section">

      {/* Contact Form Section */}
      <div className="contact-container">
        {/* Left Side Image */}
        <div className="contact-image-container">
          <img src={ContactImage} alt="Contact" className="contact-image" />
        </div>

        {/* Right Side Form */}
        <div className="contact-form-container">
          <h2 className="contact-heading">Contact Us</h2>
          <form className="contact-form">
            <input type="text" className="form-input" placeholder="Full Name" required />
            <input type="email" className="form-input" placeholder="Enter a valid email address" required />
            <input type="text" className="form-input" placeholder="Company" required />
            <input type="text" className="form-input" placeholder="US Phone" required />
            <input type="text" className="form-input" placeholder="International Phone" required />
            <textarea className="form-input" placeholder="Enter your message" rows="4" required></textarea>
            <button type="submit" className="contact-submit">Submit</button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ContactUs;